import React from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faX, faCircle } from '@fortawesome/free-solid-svg-icons'

export default function DashletDeclineIcon() {
  return (
    <span className="icon is-medium has-text-danger ml-1">
      <span
        style={{ pointerEvents: 'auto' }}
        className={`lox-no-border lox-tooltip-moveable has-tooltip-arrow has-tooltip-right has-tooltip-primary has-text-weight-normal`}
        data-tooltip={"No or False"}
      >
        <span className="fa-stack fa-sm">
          <FontAwesomeIcon icon={faCircle} className="fa-stack-1x" />
          <FontAwesomeIcon icon={faX} className="fa-stack-1x has-text-white" />
        </span>
      </span>
    </span>
  )
}
